import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import {
  CSV_Strategies,
  CSV_Strategy,
} from '../../../../../shared/ecommerce-platform-integration/csv-strategies';

@Component({
  selector: 'app-add-products-strategy-select-modal',
  templateUrl: './add-products-modal.component.html',
  styleUrl: './add-products-modal.component.scss',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
})
export class AddProductsStrategySelectModalComponent {
  @Input() products: unknown[] = [];
  @Input() storeId = '';
  @Input() storeName = '';

  // eslint-disable-next-line unicorn/consistent-function-scoping
  options = Object.entries(CSV_Strategies).map(([name, value]) => ({ name, value }));

  selectedOption: CSV_Strategy = this.options[1].value;

  modal: NgbActiveModal;

  constructor() {
    this.modal = inject(NgbActiveModal);
  }

  addProductsToStore(): void {
    this.modal.close(this.selectedOption);
  }
  closeModal(): void {
    this.modal.close();
  }
}
